import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const Text = styled(Box)(({ theme }) => ({
  color      : theme.palette.primary.black1,
  fontFamily : 'Montserrat',
  fontStyle  : 'normal',
  fontWeight : 400,
  fontSize   : '14px',
  lineHeight : '24px',
  margin     : '16px 0',
  maxWidth   : '956px',
}));
